import React from 'react'
import BooksList from '../books/BooksList'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'

type Props = {}

const TheSisList: React.FC<Props> = (props: Props) => {
    return (
        <BooksList
            category_label='วารสาร'
            category_path={routeName.e_library.the_sis}
            category_pathname_label={routeName.e_library.the_sis_list}
            library_category_name={ELibraryCategory.THESIS}
            path_detail={routeName.e_library.the_sis_detail}
            allow_shadow={true}
        />
    )
}

export default TheSisList


